import React from 'react'
import { mapFilterLabel } from 'src/utils/filter'
import { StCloseIcon, StFilterTag, StLabel } from './styles'

export const FilterTag = ({ tagLabel, onRemove }) => {
  return (
    <StFilterTag onClick={onRemove} saleTag={tagLabel === 'Sale'}>
      <StLabel>{tagLabel === 'newIn' ? 'New-In' : mapFilterLabel(tagLabel)}</StLabel>{' '}
      <StCloseIcon>x</StCloseIcon>
    </StFilterTag>
  )
}
